import { css, html, LitElement, unsafeCSS } from 'lit';
import styles from './stackItem.scss?inline';

export default class SotbitStackItem extends LitElement {
    static styles = css`
        ${unsafeCSS(styles)}
    `;

    render() {
        return html`
            <div class="stack-item__container" part="stack-item__container">
                <div class="stack-item__header" part="stack-item-header">
                    <slot name="icon-left"></slot>
                    <slot name="title"></slot>
                </div>
                <div class="stack-item__content" part="stack-item-content">
                    <slot></slot>
                </div>
            </div>
        `;
    }
}
